import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { returnUrl: String, clearUrl: String }

  async printAndReturn() {
    const printerCtrl = this.application.controllers.find(c => c.identifier === "receipt-printer")
    if (printerCtrl) {
      await printerCtrl.printReceipt()
    }
    await new Promise(resolve => setTimeout(resolve, 5000))
    await this.clearCart()
    window.location.href = this.returnUrlValue
  }

  async clearCart() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.clearUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrf, "Content-Type": "application/json" }
    })
  }
}
